import React, { useState, useEffect } from 'react';
 
const Carousel = () => {
  // Define the images
  const images = [
    'images/landin.jpeg',
    'images/landin7.jpeg',
    'images/landin3.jpeg',
 
  ];
 
  const [currentIndex, setCurrentIndex] = useState(0);
 
  // Auto-slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      goToNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);
 
  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
 
  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };
 
  return (
    <div className="relative w-full overflow-hidden ">
      {/* Image Slider */}
      <div className=" h-screen">
        <img
          src={images[currentIndex]}
          alt={`slide-${currentIndex}`}
          className="w-full absolute left-0 right-0 h-screen sm:h-[600px] md:h-[700px] lg:h-[800px] object-cover  "
        />
      </div>
 
      {/* Dots Indicator */}
      <div className="absolute bottom-32 left-0 right-0 flex justify-center space-x-2">
        {images.map((_, index) => (
          <span
            key={index}
            className={`w-3 h-3 rounded-full ${
              index === currentIndex ? 'bg-white' : 'bg-gray-400'
            }`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};
 
export default Carousel;